import * as yup from 'yup';

export const transactionBasedSchema = yup.object({
  tag: yup.string().required(),
});

export interface TransactionBasedFormOutputFields {
  tag: string;
}
